import React from "react";
import Text from "../../../components/ui/Text";

interface SkillProgressProps {
  /** Current skill level (integer) */
  level: number;
  /** Maximum level (for display & calculation) */
  maxLevel: number;
  /** Progress percentage towards the next level (0-100) */
  percentage: number;
  /** Optional extra className */
  className?: string;
}

const SkillProgress: React.FC<SkillProgressProps> = ({
  level,
  maxLevel,
  percentage,
  className,
}) => {
  const prevLevel = level > 1 ? level - 1 : "0";
  const nextLevel = level < maxLevel ? level + 1 : null;

  return (
    <div
      className={`flex flex-col items-center justify-center w-full relative ${className}`}
    >
      {/* Progress arc (rotated line) */}

      <svg
        viewBox="0 0 320 160"
        className="w-full h-40 2560px:h-[14rem] absolute bottom-0 left-0 right-0"
      >
        {/* Background semi-circle */}
        <path
          d="M 10 160 A 150 150 0 0 1 310 160"
          fill="none"
          stroke="#1f2937"
          strokeWidth="6"
          strokeLinecap="round"
        />

        {/* Progress semi-circle */}
        <path
          d="M 10 160 A 150 150 0 0 1 310 160"
          fill="none"
          stroke="#facc15"
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray="471" /* dužina polukruga: π * r */
          strokeDashoffset={471 - (471 * percentage) / 100}
          className="transition-all duration-500"
        />
      </svg>

      {/* Levels row */}
      <div className="flex items-center space-x-2 mt-14 1520px:mt-5 2560px:mt-0 text-sm font-medium gilroy-font">
        {prevLevel && (
          <Text size="2xl" className="text-white/10 !font-semibold">
            {" "}
            {prevLevel.toString().padStart(2, "0")}
          </Text>
        )}
        <Text size="2xl" className="text-white !font-semibold">
          {level.toString().padStart(2, "0")}
        </Text>
        {nextLevel && (
          <Text size="2xl" className="text-white/10 !font-semibold">
            {" "}
            {nextLevel.toString().padStart(2, "0")}
          </Text>
        )}
      </div>

      {/* Label */}
      <Text
        size="xxs"
        className="text-white/50 leading-[1] mt-3 2560px:mt-5 tracking-[9px]"
      >
        SKILL LEVEL
      </Text>
    </div>
  );
};

export default SkillProgress;
